import classnames from "classnames";
import React from 'react';
import { Translate } from "react-localize-redux";
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import AngleDownIcon from '../../img/icons/BBiconsRozbalit';
import { SECTIONS, reportActions } from '../../store/reportStore';
import { isNullOrUndefined } from '../../store/storeFunctions';
import BbCollapse from './BbCollapse';
import { JumpingBeans } from './loadingComponent';
import Message from './message';

import FinStatementsInfo from '../reportSections/finStatementsInfo';
import LiensSection from '../reportSections/liens/liensSection';
import PublicContractsSection from '../reportSections/publicContracts/publicContractsSection';
import PublicProcurementsSection from '../reportSections/publicProcurements/publicProcurementsSection';
import RelationSubSection from '../reportSections/relations/relationSubSection';

class ReportSubsection extends React.Component {
    // Group subsections by sectionId
    knownSubsections = {
        "empty": () => (""),
        [SECTIONS.relatedAddresses]: RelationSubSection,
        [`${SECTIONS.liensItems}_CR`]: LiensSection,
        [`${SECTIONS.liensItems}_DE`]: LiensSection,
        [`${SECTIONS.publicContractsItems}_01`]: PublicContractsSection,
        [`${SECTIONS.publicContractsItems}_02`]: PublicContractsSection,
        [`${SECTIONS.publicProcurements}_A`]: PublicProcurementsSection,
        [`${SECTIONS.publicProcurements}_S`]: PublicProcurementsSection,
        [SECTIONS.shortReportRelatedAddresses]: RelationSubSection,
        [`${SECTIONS.mirriPublicContractsItems}_01`]: PublicContractsSection,
        [`${SECTIONS.mirriPublicContractsItems}_02`]: PublicContractsSection,
        [SECTIONS.finStatementsInfo]: FinStatementsInfo
    };

    componentDidMount() {
        this.props.attachSectionElement(this.props.subsectionId, this.holder);
        this.props.loadIfSubsectionExpanded(this.props.sectionId, this.props.subsectionId);
    }

    componentDidUpdate(prevProps) {
        if (prevProps.report.isExpandAllActivated !== this.props.report.isExpandAllActivated && this.props.report.isExpandAllActivated) {
            this.props.loadIfSubsectionExpanded(this.props.sectionId, this.props.subsectionId);
        }
    }

    getNextSection = () => {
        let parent = this.props.report.sections.find(o => o.id === this.props.sectionId)
        if (parent === undefined || parent === null)
            return null;

        let nextId = parent.subsections.find(o => o.id === this.props.subsectionId).orderId;
        return parent.subsections.find(o => o.orderId > nextId && !o.hidden);
    }

    scrollToNextSection = () => {
        let nextSection = this.getNextSection();
        if (nextSection !== undefined)
            this.props.report.elements[nextSection.id].scrollIntoView({ behavior: "smooth", block: 'start' });
    }

    render() {
        const TagName = this.knownSubsections[this.props.subsectionId] || this.knownSubsections["empty"];
        const parentSection = this.props.report.sections.find(o => o.id === this.props.sectionId);
        if (parentSection === undefined || parentSection === null)
            return null;

        if (parentSection.subsections === undefined || parentSection.subsections === null || parentSection.subsections.length === 0)
            return null;
        if (parentSection.subsections.find(o => o.id === this.props.subsectionId) === undefined) {
            return null;
        }
        const { name, isLoading, expanded, hasData, error } = parentSection.subsections.find(o => o.id === this.props.subsectionId);
        const subsectionData = isNullOrUndefined(this.props.subsectionData) ? {} : this.props.subsectionData;

        return (
            <div data-level={this.props.level || 2} className={classnames({ 'report-section': true, 'is-expanded': expanded && hasData })} ref={(el) => this.holder = el} style={{ pointerEvents: hasData ? "auto" : "none" }}>
                <div
                    className='header-wrap header-wrap-circle-icon'
                    style={{ cursor: hasData ? "pointer" : "not-allowed" }}
                    onClick={() => this.props.toggleSubsection(this.props.sectionId, this.props.subsectionId, !expanded, this.props.subsectionId !== SECTIONS.relatedAddresses)}
                >
                    <div className="header-body"  >
                        <div className="name">{isNullOrUndefined(this.props.subsectionName) ? name : this.props.subsectionName}</div>
                        {isLoading && <JumpingBeans />}
                        {this.renderIcon(expanded, hasData)}
                    </div>
                </div>

                {hasData && !isLoading &&
                    <BbCollapse className="report-section-body" id={this.props.sectionId} tag="div" isOpen={expanded && hasData}>
                        {error && <Message type='warning' message={<Translate id={error} options={{ renderInnerHtml: true }} />} shadowed={true} />}
                        <TagName sectionId={this.props.sectionId} subsectionId={this.props.subsectionId} subsectionData={subsectionData} />
                    </BbCollapse>
                }
            </div>
        );
    }

    renderIcon = (expanded, hasData) => {
        if (hasData) {
            return (
                <div className="icon-wrap">
                    <AngleDownIcon
                        style={{ transform: `scaleY(${expanded ? -1 : 1})`, transition: 'all .5s ease', width: '1.4em', height: '1.4em' }}
                        className={classnames('svg-standard-fill', { 'print-hidden': !expanded })} />
                </div>
            );
        }
        else {
            return (
                <div className="icon-wrap">
                    <Translate id="Report.Common.SectionNoData" />
                </div>
            )
        }
    }
}

export default connect(
    state => ({ report: state.report }),
    dispatch => bindActionCreators(reportActions, dispatch)
)(ReportSubsection);